import api from './api';

const userService = {
  // Pobierz wszystkich użytkowników
  getUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  // Utwórz nowego użytkownika
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Aktualizuj użytkownika
  updateUser: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Usuń użytkownika
  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  getUserActivity: async (userId, from, to) => {
    const response = await api.get(`/users/${userId}/activity`, { params: { from, to } });
    return response.data;
  },

  downloadUserActivity: async (userId, from, to, format) => {
    try {
      const response = await api.get(`/users/${userId}/activity`, {
        params: { from, to, format, download: 1 },
        responseType: 'blob'
      });
      const disposition = response.headers['content-disposition'] || '';
      const match = disposition.match(/filename="([^"]+)"/);
      return {
        blob: response.data,
        filename: match ? match[1] : `aktywnosc.${format === 'csv' ? 'csv' : 'json'}`
      };
    } catch (error) {
      const data = error.response?.data;
      if (data instanceof Blob) {
        const text = await data.text();
        try {
          const parsed = JSON.parse(text);
          throw new Error(parsed.message || 'Nie udało się pobrać pliku');
        } catch (parseError) {
          if (parseError instanceof SyntaxError) {
            throw new Error('Nie udało się pobrać pliku');
          }
          throw parseError;
        }
      }
      throw new Error(error.response?.data?.message || 'Nie udało się pobrać pliku');
    }
  },

  // Pobierz dostęp użytkownika do folderów
  getUserFolderAccess: async (userId) => {
    const response = await api.get(`/users/${userId}/folder-access`);
    return response.data;
  },

  // Przypisz dostęp do folderu dla użytkownika
  assignFolderAccess: async (userId, deviceId, folderPath, folderName, permissions) => {
    const response = await api.post(`/users/${userId}/assign-folder`, {
      deviceId,
      folderPath,
      folderName,
      permissions
    });
    return response.data;
  },

  // Masowo przypisz dostęp do folderu
  bulkAssignFolderAccess: async (userIds, deviceId, folderPath, folderName, permissions) => {
    const response = await api.post('/users/bulk-assign-folder', {
      userIds,
      deviceId,
      folderPath,
      folderName,
      permissions
    });
    return response.data;
  },

  // Masowo usuń dostęp do folderu
  bulkRemoveFolderAccess: async (userIds, deviceId, folderPath) => {
    const response = await api.post('/users/bulk-remove-folder', {
      userIds,
      deviceId,
      folderPath
    });
    return response.data;
  },

  // Usuń dostęp użytkownika do folderu
  removeFolderAccess: async (userId, accessId) => {
    const response = await api.delete(`/users/${userId}/folder-access/${accessId}`);
    return response.data;
  },

  // Pobierz dostępne foldery do przypisania
  getAvailableFolders: async () => {
    const response = await api.get('/users/available-folders');
    return response.data;
  },

  // Pobierz zbiorcze zestawienie dostępu do folderów dla wszystkich użytkowników
  getFolderAccessSummary: async () => {
    const response = await api.get('/users/folder-access-summary');
    return response.data;
  },

  // Zmień hasło użytkownika (tylko admin)
  changeUserPassword: async (userId, newPassword) => {
    const response = await api.post(`/users/${userId}/change-password`, {
      newPassword
    });
    return response.data;
  },

  // Przeglądaj podfoldery w folderze użytkownika
  browseUserFolder: async (deviceId, folderPath) => {
    // Enkoduj ścieżkę folderu dla URL
    const encodedPath = encodeURIComponent(folderPath);
    console.log('[userService] browseUserFolder - folderPath:', folderPath);
    console.log('[userService] browseUserFolder - encodedPath:', encodedPath);
    const response = await api.get(`/users/browse/${deviceId}/${encodedPath}`);
    console.log('[userService] browseUserFolder - response:', response.data);
    return response.data;
  },

  // Utwórz nowy folder na NAS
  createFolder: async (deviceId, folderPath, folderName) => {
    const response = await api.post(`/users/create-folder/${deviceId}`, {
      folderPath,
      folderName
    });
    return response.data;
  },

  // Zmień nazwę folderu na NAS
  renameFolder: async (deviceId, folderPath, oldName, newName) => {
    const response = await api.post(`/users/rename-folder/${deviceId}`, {
      folderPath,
      oldName,
      newName
    });
    return response.data;
  }
};

export default userService;
